import { useMutation } from "@tanstack/react-query";
import { IAddress } from "../types/seed";
import { createApiError } from "../utils/apiError";

const API = process.env.REACT_APP_API;

const useSignup = () => {
  const mutationFn = async ({
    address,
    address_obj,
    email,
    name,
    password,
    phone,
  }: {
    address?: string;
    address_obj?: IAddress | null;
    email: string;
    name: string;
    password: string;
    phone: string;
  }) => {
    const response = await fetch(
      `${API}/api/feira_online/urban_partner/register`,
      {
        method: "POST",
        body: JSON.stringify({
          address,
          address_obj,
          email,
          name,
          password,
          phone,
        }),
        headers: {
          "Content-Type": "application/json",
        },
      },
    );

    if (!response.ok) {
      throw await createApiError(response);
    }

    return await response.json();
  };

  return useMutation({
    mutationFn,
  });
};

export default useSignup;
